import { PageUtils } from "./helpers/page-utils";

function closeLightBox(lightbox) {
    lightbox.dataset.visible = 'false';
    PageUtils.bodyLockToggleOff();
    const scrollCta = document.querySelector('button[data-scroll-cta]');
    const hubspotChat = document.getElementById('hubspot-messages-iframe-container');
    const siteHeader = document.getElementById('siteHeader');
    if (scrollCta) {
        scrollCta.classList.remove('hidden');
    }
    if (hubspotChat) {
        hubspotChat.classList.remove('opacity-0','pointer-events-none');
    }
    if (siteHeader) {
        const headerHeight = siteHeader.getBoundingClientRect().height;
        const scrollDistance = window.scrollY || document.documentElement.scrollTop;

        if (scrollDistance <= headerHeight) {
            siteHeader.dataset.visible = 'true';
        }
    }
    setTimeout(() => {
        lightbox.remove();
    }, 300);
}

function openLightBox(lightbox) {
    lightbox.dataset.hidden = 'false';
    PageUtils.bodyLockToggleOn();

    const docBody = document.body;
    const siteHeader = document.getElementById('siteHeader');
    const scrollCta = document.querySelector('button[data-scroll-cta]');
    const hubspotChat = document.getElementById('hubspot-messages-iframe-container');
    if (scrollCta) {
        scrollCta.classList.add('hidden');
    }
    if (hubspotChat) {
        hubspotChat.classList.add('opacity-0','pointer-events-none');
    }
    siteHeader.dataset.visible = 'false';
    docBody.dataset.navVisible = 'false';

    setTimeout(() => {
        lightbox.dataset.visible = 'true';
    }, 50);
}

window.addEventListener("load", () => {
    const searchButtons = document.querySelectorAll("button[data-open-search]");

    if (!searchButtons) return;

    for (const searchButton of searchButtons) {
        searchButton.addEventListener("click", (event) => {
            // Create the lightbox element
            const lightbox = document.createElement('div');
            lightbox.dataset.lightboxSearch = '';
            lightbox.dataset.hidden = 'true';
            lightbox.dataset.visible = 'false';
            lightbox.className =
                "w-screen h-screen flex items-center ios-vh-fix z-[99999] fixed top-0 left-0 transition-opacity duration-300 backdrop-blur-md data-[visible=false]:pointer-events-none data-[visible=false]:opacity-0 data-[hidden=true]:hidden";

            lightbox.innerHTML = `
                <div class="max-w-8xl mx-auto relative w-full h-full z-1 p-8">
                    <div class="w-full h-full relative flex items-center justify-center">
                        <form class="w-full relative max-w-[27.375rem]" action="/search">
                            <label for="pageSearchInput" class="absolute inset-0 w-full h-full z-0"></label>
                            <input required class="text-black h-12 md:h-16 pl-4 pr-16 py-2 w-full rounded-md !shadow-lg bg-white border border-green-brand hover:border-green-brand focus:border-green-brand active:border-green-light transition-colors duration-300 ease-in-out !outline-0 !ring-0 !ring-transparent !shadow-none !drop-shadow-none" placeholder="Search" type="search" name="q" id="pageSearchInput" value="">
                            <button type="submit" title="Click to begin search" class="group/button w-12 h-12 md:h-16 absolute rounded-r-md border-r border-y border-green-brand right-0 top-1/2 -translate-y-1/2 z-1 bg-cream">
                                <svg class="fill-green-brand w-6 h-6 m-auto pointer-events-none group-hover/button:scale-110 transition-all duration-300" width="26" height="26" viewBox="0 0 26 26" fill="#000" xmlns="http://www.w3.org/2000/svg"><path d="m24.848 23.434-5.475-5.473c3.388-4.102 3.166-10.202-.67-14.039A10.382 10.382 0 0 0 11.31.859a10.384 10.384 0 0 0-7.39 3.063 10.384 10.384 0 0 0-3.063 7.391 10.38 10.38 0 0 0 3.062 7.391 10.386 10.386 0 0 0 7.392 3.063c2.456 0 4.781-.844 6.65-2.389l5.472 5.471a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.415ZM5.334 17.289a8.399 8.399 0 0 1-2.476-5.977 8.4 8.4 0 0 1 2.476-5.977 8.401 8.401 0 0 1 5.978-2.477c2.257 0 4.38.88 5.977 2.477 3.296 3.295 3.296 8.658 0 11.953a8.393 8.393 0 0 1-5.977 2.477 8.402 8.402 0 0 1-5.978-2.476Z" fill="inherit"/></svg>
                            </button>
                        </form>
                    </div>
                </div>
                <div class="absolute pointer-events-none w-full h-full max-w-8xl mx-auto top-0 left-1/2 -translate-x-1/2 z-3">
                    <button type="button" title="Click to close lightbox" data-lightbox-close
                        class="!ring-0 !ring-transparent absolute right-4 top-4 w-10 h-10 bg-green-brand rounded-lg cursor-pointer pointer-events-auto xs:top-4 xs:right-4 lg:top-8 lg:right-8 xs:bg-opacity-20 group">
                       <svg class="fill-white w-10 h-10 p-2 pointer-events-none group-hover:scale-110 transition-all duration-300 group-hover:rotate-90" width="40" height="40" viewBox="0 0 40 40" fill="#000" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.29 20.0001L30.65 10.6401C31.01 10.2901 31.01 9.71008 30.65 9.35008C30.29 8.99008 29.72 8.99008 29.36 9.35008L20 18.7101L10.64 9.35008C10.29 8.99008 9.70996 8.99008 9.34996 9.35008C8.98996 9.70008 8.98996 10.2801 9.34996 10.6401L18.71 20.0001L9.34996 29.3601C8.98996 29.7101 8.98996 30.2901 9.34996 30.6501C9.52996 30.8301 9.75996 30.9201 9.98996 30.9201C10.22 30.9201 10.46 30.8301 10.63 30.6501L19.99 21.2901L29.35 30.6501C29.53 30.8301 29.76 30.9201 29.99 30.9201C30.22 30.9201 30.45 30.8301 30.63 30.6501C30.99 30.3001 30.99 29.7201 30.63 29.3601L21.27 20.0001H21.29Z" fill="inherit"/>
                        </svg>
                    </button>
                </div>
                <div data-lightbox-backdrop class="absolute top-0 left-0 w-full h-full bg-green-brand/75 z-0"></div>
            `;

            // Append the lightbox to the document body
            document.body.appendChild(lightbox);

            // Run the openLightBox function
            openLightBox(lightbox);

            const searchInput = lightbox.querySelector('input');

            if (searchInput) {
                searchInput.focus();
            }

            // Add event listeners for close interactions
            const lightboxBackdrop = lightbox.querySelector('[data-lightbox-backdrop]');
            const lightboxClose = lightbox.querySelector('[data-lightbox-close]');

            const closeHandler = () => {
                closeLightBox(lightbox);
                cleanup();
            };

            const keydownHandler = (event) => {
                if (event.key === 'Escape') {
                    closeLightBox(lightbox);
                    cleanup();
                }
            };

            const cleanup = () => {
                // Remove event listeners
                if (lightboxBackdrop) lightboxBackdrop.removeEventListener('click', closeHandler);
                if (lightboxClose) lightboxClose.removeEventListener('click', closeHandler);
                document.removeEventListener('keydown', keydownHandler);
            };

            if (lightboxBackdrop) {
                lightboxBackdrop.addEventListener('click', closeHandler);
            }
            if (lightboxClose) {
                lightboxClose.addEventListener('click', closeHandler);
            }
            document.addEventListener('keydown', keydownHandler);
        });
    }
});
